import { render, staticRenderFns } from "./BackNav.vue?vue&type=template&id=4ee57047&scoped=true&"
import script from "./BackNav.vue?vue&type=script&lang=js&"
export * from "./BackNav.vue?vue&type=script&lang=js&"
import style0 from "./BackNav.vue?vue&type=style&index=0&id=4ee57047&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee57047",
  null
  
)

export default component.exports